/*
 * AdminUsers Messages
 *
 * This contains all the text for the AdminUsers component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  addStudents: {
    id: 'app.components.AdminUsers.addStudents',
    defaultMessage: 'Add Students',
  },
  inviteStudents: {
    id: 'app.components.AdminUsers.inviteStudents',
    defaultMessage: 'Invite Students',
  },
  individualStudent: {
    id: 'app.components.AdminUsers.individualStudent',
    defaultMessage: 'Add Individual Student',
  },
  importStudents: {
    id: 'app.components.AdminUsers.importStudents',
    defaultMessage: 'Import Multiple Students',
  },
  addStudent: {
    id: 'app.components.AdminUsers.addStudent',
    defaultMessage: 'Add Student',
  },
  firstName: {
    id: 'app.components.Name.firstName',
    defaultMessage: 'First name',
  },
  middleName: {
    id: 'app.components.AdminGroups.middleName',
    defaultMessage: 'Affix',
  },
  lastName: {
    id: 'app.components.Name.lastName',
    defaultMessage: 'Last name',
  },
  birthDate: {
    id: 'app.components.AdminUsers.birthDate',
    defaultMessage: 'Date of Birth',
  },
  adminGroup: {
    id: 'app.components.AdminGroups.adminGroup',
    defaultMessage: 'Administrative Group',
  },
  select: {
    id: 'app.dropdown.select',
    defaultMessage: 'Select…',
  },
  yearClass: {
    id: 'app.components.LibraryGoalEditor.gradeLabel',
    defaultMessage: 'Grade',
  },
});
